export const REPORTS_COPY = {
    TITLE: 'Reports',
    TAB_CATALOGUE: 'Catalogue',
    TAB_TEMPLATES: 'Templates',
    TAB_STORE_BRANDS: 'Store brands',
    NEW_REPORT: 'New report',
    NEW_TEMPLATE: 'New template',
    COPY_FROM_BRAND: 'Copy from a store brand that’s already using reports',
    SEARCH_CATALOGUE: 'Search reports',
    SEARCH_TEMPLATES: 'Search templates',
    SEARCH_TEMPLATES_APPLY: 'Search a template by name or tag',
    SEARCH_STORE_BRANDS: 'Search a store brand by name',
    CLEAR_FILTERS: 'Clear all',
    CLEAR_SEARCH_FILTERS: 'Clear search and filters',
    LOAD_NEXT: 'Load the next 25',
    END_OF_LIST: 'End of list',
    COPY_ID: 'Copy ID',
    COPIED: 'Copied',
    ALL_STATES: 'All states',
    EVERY_STORE_BRAND: 'Every store brand',
    CAN_BUILD: 'Can build a file',
    CANNOT_BUILD: 'Cannot build a file',
    ALREADY_IN_REPORT: 'Already in this report',
    ALREADY_ON: 'Already on',
    ALREADY_IN_TEMPLATE: 'Already in this template',
    CURRENTLY_ON: 'Currently on',
    TEMPLATES: 'Templates',
    ON_FOR_STORE_BRANDS: 'On for store brands',
    SAVE: 'Save',
    SAVE_CHANGES: 'Save changes',
    SAVED: 'Saved',
    DISCARD_TICKS: 'Discard these ticks',
    CONTINUE: 'Continue',
    CONFIRM: 'Confirm',
    CANCEL: 'Cancel',
    RETRY: 'Retry',
    DUPLICATE: 'Duplicate',
    APPLY_TEMPLATE: 'Apply this template to store brands',
    PICKED_TO_APPLY: 'Picked to apply',
    REPORT_DETAILS: 'Report details',
    WHICH_FILE: 'Which file this runs',
    LINK_BUILDER: 'Link a builder',
    UNLINK: 'Unlink',
    WHAT_THEY_PICK: 'What they pick when they download',
    DATE_TYPE: 'Date type',
    FILE_TYPE: 'File type',
    DATA_POINTS: 'Data points',
    TIME_SAVED: 'Time saved',
    REPORT_NAME_FOR_BRAND: 'Report name for this store brand',
    SAVE_THIS_NAME: 'Save this name',
    CLEAR_THE_NAME: 'Clear the name',
    ALWAYS_ON_LINE: 'Always-on reports are already available to every store brand.',
    EMPTY_CATALOGUE_TITLE: 'No reports in the menu',
    EMPTY_CATALOGUE_BODY: 'Create a report to start the catalogue.',
    EMPTY_TEMPLATES_TITLE: 'No templates yet',
    EMPTY_TEMPLATES_BODY:
        'Create a template, or copy one from a store brand that is already using reports.',
    EMPTY_BRANDS_TITLE: 'Search a store brand to see it here',
    EMPTY_BRANDS_BODY:
        'Nothing is listed until you search one by name. Catalogue and Templates work with no store brand typed — this is a search, not a way in.',
    EMPTY_BRANDS_ONE_CHAR:
        'One character is not enough to search on. Type at least two and the store brands that match appear here.',
    SELECT_ALL_MATCHING: 'Select all matching filters',
    CLEAR_SELECTION: 'Clear selection',
    APPLY_TEMPLATE_TO_SELECTED: 'Apply a template to selected',
    FILTERED_EMPTY_BRANDS: 'No store brand matches what you have on',
    FILTERED_EMPTY_BRANDS_CAUSE:
        'The search and the state filter caused this, not an empty system.',
    LOADING_BRANDS: 'Matching the store brands to that search…',
    LOADING_NEXT_BRANDS: 'Getting the next 25…',
    ERROR_BRANDS_TITLE: 'Couldn’t load the store brands',
    ERROR_BRANDS_BODY:
        'The store brands you can assign to did not come back, so this is not an empty system. The catalogue and the templates are loaded separately and are unaffected.',
    RETRY_BRANDS: 'Retry the store brands',
    RETRY_NEXT: 'Retry the next 25',
    MORE_FAILED_TITLE: 'Couldn’t load the next 25',
    MORE_FAILED_BODY:
        'The next page did not come back. The rows above are still the ones that loaded, the counts still stand, and nothing has been wiped.',
    OPEN_STORE_BRAND: 'Open this store brand',
    NONE_ON: 'none on',
    REPORT_ON: 'report on',
    REPORTS_ON_NOTE: 'reports on',
    LAST_TOGGLE_TODAY: 'Last toggle today',
    LAST_TOGGLE_1: 'Last toggle 1 day ago',
    FILTERED_EMPTY: 'Nothing matches that search and those filters.',
    SEARCH_STORE_BRAND_HINT: 'Type at least 2 characters to search.',
    KIND_GENERATED: 'Shop can download',
    KIND_ALWAYS_ON: 'Always on',
    KIND_DEAD: 'Doesn’t run yet',
    NO_TAGS: 'No tags',
    EMPTY_RECIPE: 'Empty recipe — allowed',
    NONE_IN_IT: 'none in it',
    NO_TOGGLE: 'No toggle recorded',
    ALREADY_IN_FILTER: 'Already in this report',
    ALREADY_ON_FILTER: 'Already on',
    CURRENTLY_ON_FILTER: 'Currently on',
    SELECTED_STORE_BRAND: 'Selected store brand',
    NEW_TEMPLATE_NAME: 'New template name',
    BACK_TO_TEMPLATES: 'Back to the templates list',
    STEP_1: 'Step 1 · Template details',
    STEP_2: 'Step 2 · Reports in this template',
    SAVED_IN_TEMPLATES: 'Saved. This report is in',
    SAVED_ON_BRANDS: 'Saved. This report is on for',
    SAVED_NO_TICK: 'Saved. No tick had changed.',
    NO_TICK_CHANGE: 'No tick change',
    LOADING_NAME: 'Loading the name saved for this store brand…',
    LICENCE_EMPTY: 'No licence types for the picked states.',
    RETRY_TAGS: 'Couldn’t load tags · Retry',
    RETRY_CATEGORIES: 'Couldn’t load categories · Retry',
    RETRY_CATALOGUE: 'Couldn’t load the catalogue · Retry',
    OPTIONS_FAIL_BODY: 'The options did not come back. Nothing on the list changed.',
    LOADING_STATES: 'Loading states…',
    LOADING_CATEGORIES: 'Loading categories…',
    LOADING_TAGS: 'Loading tags…',
    LOADING_LICENCES: 'Loading licence types…',
    LOAD_FAIL_STATES: 'Couldn’t load states',
    LOAD_FAIL_CATEGORIES: 'Couldn’t load categories',
    LOAD_FAIL_TAGS: 'Couldn’t load tags',
    LOAD_FAIL_LICENCES: 'Couldn’t load licence types',
    SAVE_NOTHING_WRITTEN:
        'Nothing was written. Everything you typed is still on this form — retry the save when you are ready.',
    RETRY_THE_SAVE: 'Retry the save',
    RETRY_THIS_TEMPLATE: 'Retry this template',
    DAILY_WHATSAPP: 'Daily WhatsApp',
    APPLY_TO_BRANDS: 'Apply this template',
    PICKED_CARD: 'Picked to apply',
} as const;

export const REPORTS_TIPS = {
    CATALOGUE: {
        title: 'Catalogue',
        body: 'Every report that exists, including ones shops never see on Generate Report.',
    },
    TEMPLATE: {
        title: 'Template',
        body: 'A named group of reports. Applying it turns those reports on. Changing the template later does not change any store brand.',
    },
    STORE_BRAND: {
        title: 'Store brand',
        body: 'The liquor group (for example Sharma Wine), not a product brand like Kingfisher.',
    },
    KIND: {
        title: 'Kind',
        body: 'Shop can download is a Generate Report card. Always on is already available everywhere. Doesn’t run yet has no builder.',
    },
    KIND_GENERATED: {
        title: 'Shop can download',
        body: 'Merchants can generate this once it is on for their store brand.',
    },
    KIND_ALWAYS_ON: {
        title: 'Always on',
        body: 'Every store brand already has this. Merchants open it from Customers, Inventory, or Sales — not Generate Report. You cannot add it to a template or turn it on or off.',
    },
    KIND_DEAD: {
        title: 'Doesn’t run yet',
        body: 'This is in the catalogue, but we cannot build a file. You cannot turn it on for a store brand until a builder is linked.',
    },
    CAN_BUILD: {
        title: 'Can build a file',
        body: 'We can produce the Excel or PDF for this report.',
    },
    CANNOT_BUILD: {
        title: 'Cannot build a file',
        body: 'Nothing will produce a file for this id. Turning it on for a store brand would not help.',
    },
    NOT_A_TOGGLE: {
        title: 'Not a toggle',
        body: 'Always on is not turned on per store brand. It is already available to every store brand.',
    },
    ON_FOR_STORE_BRANDS: {
        title: 'On for store brands',
        body: 'How many store brands have this turned on. Zero is a number.',
    },
    ACTIVE: {
        title: 'Active',
        body: 'Inactive reports stay in the catalogue. They cannot be added to a template or turned on.',
    },
    WHICH_FILE: {
        title: 'Which file this runs',
        body: 'Pick a builder that already exists. The name in this list is the builder’s name. The catalogue name is what you type on this report.',
    },
    DATE_TYPE: {
        title: 'Date type',
        body: 'Shops pick one day or a date range when they download this report.',
    },
    FILE_TYPE: {
        title: 'File type',
        body: 'Whether shops see Excel or PDF radios, which formats exist, which is pre-selected, and whether they can change it. Most reports hide this.',
    },
    DATA_POINTS: {
        title: 'Data points',
        body: 'Shown on generate. Shops cannot uncheck or reorder. Empty means no table.',
    },
    TIME_SAVED: {
        title: 'Time saved',
        body: 'Number plus minutes or hours. History shows that shops saved that time. Same for every store brand. Not something shops pick when they download.',
    },
    NAME_OVERRIDE: {
        title: 'Report name for this store brand',
        body: 'Leave this blank to use the catalogue name. If you save a name here, shops see only that name on Generate Report for this store brand. It does not change the file they download.',
    },
    TURN_ON_OR_OFF: {
        title: 'Turn on or off',
        body: 'Tick means this report is on for this store brand. Save writes the ticks. Always on is not a tick.',
    },
    DAILY_WHATSAPP: {
        title: 'Daily WhatsApp',
        body: 'Shop-can-download reports that are already on. Stored as the catalogue id. Always on cannot be picked.',
    },
    NOT_IN_TEMPLATE: {
        title: 'Not in a template',
        body: 'Tick puts this report in the template. Always on cannot go in.',
    },
} as const;
